// ProtectedRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [isAuth, setIsAuth] = useState(false);
  const [isValidating, setIsValidating] = useState(true);
  const userToken = useSelector((state) => state.gtm.userToken);

  useEffect(() => {
    const checkAuth = () => {
      try {
        const token = userToken || localStorage.getItem('userToken');
        
        if (!token) {

          setIsAuth(false);
          return;
        }

        // Basic token validation (check if it exists and looks like a token)
        const isValidToken = typeof token === 'string' && token.length > 10;
        
        if (isValidToken) {

          setIsAuth(true);
        } else {

          localStorage.removeItem('userToken');
          setIsAuth(false);
        }
      } catch (error) {
        console.error('Auth check error:', error);
        setIsAuth(false);
      } finally {
        setIsValidating(false);
      }
    };

    checkAuth();
  }, [userToken]);

  if (isValidating) {
    return <div>Loading...</div>; 
  }

  if (!isAuth) {

    return (
      <Navigate
        to="/login"
        state={{ 
          from: location,
          message: 'Please login to access this page'
        }}
        replace
      />
    );
  }

  return children;
}